import React from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import { EMPLOYEE_BTN } from "./Employees/employeeTheme";

const UnsavedChangesDialog = ({
  isOpen,
  onDismiss,
  onSaveAndLeave,
  onLeaveWithoutSaving,
  isSaving = false,
  title = "Unsaved changes",
  message = "You have unsaved changes. Choose whether to save before leaving or discard your changes.",
}) => (
  <Modal isOpen={isOpen} onClose={onDismiss} title={title} size="sm">
    <p className="text-slate-600 text-sm mb-2">{message}</p>
    <div className="flex flex-row flex-wrap justify-end items-center gap-2 pt-5 mt-4 border-t border-indigo-100">
      <button
        type="button"
        onClick={onLeaveWithoutSaving}
        disabled={isSaving}
        className={`shrink-0 ${EMPLOYEE_BTN.cancel}`}
      >
        Leave without saving
      </button>
      <button
        type="button"
        onClick={onSaveAndLeave}
        disabled={isSaving}
        className={`shrink-0 ${EMPLOYEE_BTN.primary}`}
      >
        {isSaving ? "Saving…" : "Save and leave"}
      </button>
    </div>
  </Modal>
);

UnsavedChangesDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSaveAndLeave: PropTypes.func.isRequired,
  onLeaveWithoutSaving: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default UnsavedChangesDialog;
